// TEACHER
export const APP_TEACHER_LOGIN_SCREEN = '/trainer/login';

// STUDENT
export const APP_STUDENT_LOGIN_SCREEN = '/student/login';
